import { IResponse } from "../types";
import {
  ILoginCodeResponse,
  IRegisterRequest,
  IUserAuthResponse,
  TLoginGoogleRequest,
  TLoginRequest,
  TLoginWithCodeRequest,
  TSendCodeRequest,
  TSendCodeWithoutLoginRequest,
  TSetPasswordRequest,
} from "../types/auth.types";
import { api } from "./api";

export const authApi = api.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation<IUserAuthResponse, TLoginRequest>({
      query: ({ email, password }) => ({
        url: `user/login`,
        method: "POST",
        body: {
          email: email,
          password: password,
          roleId: 1
        },
      }),
    }),
    loginGoogle: build.mutation<IUserAuthResponse, TLoginGoogleRequest>({
      query: (body) => ({
        url: `user/login/google`,
        method: "POST",
        body,
      }),
    }),
    loginWithCode: build.mutation<ILoginCodeResponse, TLoginWithCodeRequest>({
      query: ({ phone, usersId }) => ({
        url: `user/code`,
        method: "POST",
        body: JSON.stringify({
          phone,
          code: "0",
          roleId: "1",
          usersId,
        }),
      }),
    }),
    authWithCode: build.mutation<IUserAuthResponse, TSendCodeRequest>({
      query: ({ phone, code, roleId, email, password, usersId }) => ({
        url: `user/authWithCode`,
        method: "POST",
        body: JSON.stringify({
          phone,
          usersId,
          code,
          roleId: String(roleId),
          email: email ?? "",
          password: password ?? "",
        }),
      }),
    }),
    sendCodeWithoutLogin: build.mutation<ILoginCodeResponse, TSendCodeWithoutLoginRequest>({
      query: (body) => ({
        url: `user/codeWithoutLogin`,
        method: "POST",
        body,
      }),
    }),
    authWithoutLogin: build.mutation<IUserAuthResponse, TSendCodeRequest>({
      query: (body) => ({
        url: `user/authWithoutLogin`,
        method: "POST",
        body,
      }),
    }),
    // sendCode: build.mutation<IUserAuthResponse, TSendCodeRequest>({
    //   query: ({ phone, code }) => ({
    //     url: `user/auth`,
    //     method: "POST",
    //     body: JSON.stringify({ phone: phone, code: code }),
    //   }),
    // }),
    logout: build.mutation<IResponse, string>({
      query: (refreshToken) => ({
        url: `/logout`,
        method: "POST",
        body: {
          token: refreshToken,
        },
      }),
    }),
    register: build.mutation<IUserAuthResponse, IRegisterRequest>({
      query: ({
        usersFlowId,
        firstName,
        lastName,
        phone,
        passport,
        email,
        password,
        birth,
        genderId,
        country,
      }) => ({
        url: `user/signup/${usersFlowId}`,
        method: "POST",
        body: {
          firstName,
          lastName,
          phone,
          passport: passport.toString(),
          email,
          password,
          birth,
          genderId,
          country,
        },
      }),
    }),
     changePassword: build.mutation<
      { success: boolean },
      { currentPassword: string; newPassword: string }
    >({
      query: (body) => ({
        url: '/Admintech/account/change-password',
        method: 'POST',
        body,
      }),
    }),
    restorePassword: build.mutation<IResponse, string>({
      query: (emailOrPhone) => ({
        url: `/restore_password`,
        method: "POST",
        body: {
          emailOrPhone,
        },
      }),
    }),
    // enterAsGuest: build.query<IUserAuthResponse, number>({
    //   query: (usersFlowId) => ({
    //     url: `user/signup/${usersFlowId}`,
    //     method: "POST",
    //   }),
    // }),
    SwitchCompanyUser: build.mutation<
      { accessToken: string; success: boolean },
      {guid: string, companyId: number}
    >({
      query: ({guid, companyId}) => ({
        url: `user/SwitchCompanyUserToken/${companyId}`,
        method: "POST",
        body: JSON.stringify(guid),
      }),
    }),
   
  }),
});

export const {
  useRestorePasswordMutation,
  useRegisterMutation,
  useLoginGoogleMutation,
  useChangePasswordMutation,
  useSendCodeWithoutLoginMutation,
  useAuthWithoutLoginMutation,
  useLoginWithCodeMutation,
  useAuthWithCodeMutation,
  useSwitchCompanyUserMutation,
  // useSendCodeMutation,
} = authApi;
